export default __webpack_public_path__ + "static/media/fpb61000.23154185.png";